import type { PrintTemplate } from "@repo/types";
import type { PrintFieldDef, PrintSectionDef } from "./types";

/** Contrôles propres au registre (le schéma Zod vérifie déjà la forme) : renvoie la liste des erreurs, vide si valide. */
export function validateTemplate<TData>(
  template: PrintTemplate,
  sections: PrintSectionDef[],
  fields: PrintFieldDef<TData>[],
): string[] {
  const errors: string[] = [];
  const sectionIds = new Set(sections.map((s) => s.id));
  const fieldByKey = new Map(fields.map((f) => [f.key, f]));

  const seenSections = new Set<string>();
  for (const section of template.sections) {
    if (seenSections.has(section.id))
      errors.push(`Section en double : ${section.id}`);
    seenSections.add(section.id);
    if (section.kind === "builtin" && !sectionIds.has(section.id))
      errors.push(`Section inconnue : ${section.id}`);

    const seenFields = new Set<string>();
    for (const item of section.items) {
      const field = fieldByKey.get(item.field);
      if (!field) errors.push(`Champ inconnu : ${item.field}`);
      else if (field.locked && !item.visible)
        errors.push(`Le champ « ${field.label} » ne peut pas être masqué`);
      if (seenFields.has(item.field))
        errors.push(`Champ en double dans ${section.id} : ${item.field}`);
      seenFields.add(item.field);
      if (item.col > section.columns)
        errors.push(
          `Colonne ${item.col} hors de la section ${section.id} (${section.columns} colonnes)`,
        );
    }
  }
  return errors;
}
